import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { Actions as PAYROLL_ACTIONS } from "../../../store/actions/payrollActions";
import ReportBtn from "../../report/DownloadReportButton";

import { CheckBadgeIcon, ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import SomethingIsOffModal from "../SomethingIsOffModal";
import apiURL from "../../../store/actions/apiURL";
import { roundTo2 } from "@/components/common/validation/Validators";
import { cloneDeep } from "lodash";
import PayrollReviewReport from "./PayrollReviewReport";

const getPeriodTotals = (payslips) => {
	let periodTotal = 0;
	payslips?.forEach(({ net, taxes }) => {
		periodTotal += parseFloat(net) || 0;
		const totalEmployeeTaxes = taxes.reduce((acc, tax) => (acc += parseFloat(tax.employeeContribution) || 0), 0);
		const totalEmployerTaxes = taxes.reduce((acc, tax) => (acc += parseFloat(tax.employerContribution) || 0), 0);

		periodTotal += totalEmployeeTaxes;
		periodTotal += totalEmployerTaxes;
	});

	return periodTotal;
};

const PayrollApproval = ({
	profile,
	advisor,
	setOpenModal,
	period,
	approvePayPeriod,
	org,
	periodTotal,
	notReadyTotal,
	currency,
	readyEmployees,
	notReadyEmployees,
}) => {
	const amend = !!period?.clientReview; //Temporary variable for testing purpos

	const periodTitle = "";

	const [reports, setReports] = useState([]);
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [checkGroupBy, setcheckGroupBy] = useState(false);
	const [totalsOnly, setTotalsOnly] = useState(false);
	const [departmentFilter, setDepartmentFilter] = useState("All");

	useEffect(() => {
		// set loaded right away to avoid a re-trigger
		fetch(apiURL + "/report/templates/", {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				// obtained data
				// console.log('data para report',data)
				setReports([
					...fixedReports,
					...data.reports.map((r) => ({
						...r,
						supportedFileTypes: ["xlsx"],
						method: "s3Link",
					})),
				]);
			});
	}, [org]);

	useEffect(() => {
		setStartDate(new Date(period.periodStart));
		setEndDate(new Date(period.periodEnd));
	}, [period]);

	const fixedReports = [
		{
			id: `timesheetLeaveReport`,
			path: `/settings/timesheetLeaveReport`,
			name: `Timesheet & Leave Hours`,
			reportType: `timesheetLeave`,
			supportedFileTypes: ["xlsx"],
			method: "s3Link",
			company: 0,
		},
	];

	return (
		<>
			<div
				className="block text-center bg-white"
				style={{ paddingTop: 40 }}
			>
				<div className="main">
					<h1 className="font-w700 text-center">Hey {profile?.givenName || "User"}!</h1>
					{amend ? (
						<>
							<h4 className="text-center">
								{advisor?.givenName || "Your Advisor"} has amended payroll for this payroll and
								requested your approval.
								{/* with the following message */}
							</h4>
							{/* <div
								className="col-auto"
								style={{ width: "100%", margin: "auto", marginTop: 10 }}
							>
								<textarea
									className="form-control form-input"
									type="text"
									name="comment"
									style={{ minHeight: 100, maxHeight: 400, resize: "none" }}
									disabled={true}
									value={"Placeholder message"}
								></textarea>
							</div> */}
						</>
					) : (
						<h4 className="text-center">
							{advisor?.givenName || "Your Advisor"} has completed payroll for this payroll and requested
							your approval.
						</h4>
					)}
					<h3
						className="text-center"
						style={{ marginTop: 50 }}
					>
						Total payroll cost for {readyEmployees} Employees:{" "}
						<strong style={{ textDecoration: "underline" }}>
							{currency}
							{roundTo2(periodTotal)}
						</strong>
					</h3>
					{notReadyEmployees ? (
						<p>
							<ExclamationTriangleIcon
								className="h-7 w-7 text-danger"
								style={{ verticalAlign: "sub" }}
							/>
							{notReadyEmployees} Payslip{notReadyEmployees === 1 ? " is" : "s are"} not ready
						</p>
					) : null}
				</div>
				<div
					className="row d-flex justify-content-center"
					style={{ width: "75%", margin: "auto" }}
				>
					<PayrollReviewReport />
					<div>
						<button
							type="button"
							className="btn btn-success"
							onClick={() => approvePayPeriod(period?.id)}
						>
							<CheckBadgeIcon style={{ height: "1.5em", float: "left" }} />
							<div style={{ float: "left", marginLeft: 5 }}>Approve</div>
						</button>
						<button
							type="button"
							className="btn btn-warning"
							style={{ marginLeft: "4em" }}
							onClick={() => setOpenModal()}
						>
							<div>Something is off</div>
						</button>
					</div>
					{reports?.map((report) => {
						if (report.name != "Payroll Report") return;
						return (
							<ReportBtn
								as="button"
								report={report}
								key={report.id}
								enabled={true}
								startDate={startDate}
								endDate={endDate}
								checkGroupBy={checkGroupBy}
								totalsOnly={totalsOnly}
								departmentFilter={departmentFilter}
								showModalOnPress={["4498c949-b3bf-4e7a-9a5d-7ee14aa92d5a"].includes(report.id)}
							/>
						);
					})}
				</div>
			</div>
			<SomethingIsOffModal />
		</>
	);
};

const mapStateToProps = (state) => {
	const employeesThisPayroll = state?.payroll?.employees || [];
	const payslips = cloneDeep(employeesThisPayroll)?.map?.(({ payslip, taxes }) => {
		payslip.taxes = taxes;
		return payslip;
	});

	const ready = payslips?.filter(({ ready }) => ["yes", "true", true].includes(ready));
	const notReady = payslips?.filter(({ ready }) => !["yes", "true", true].includes(ready));

	const [periodTotal, notReadyTotal] = [ready, notReady].map(getPeriodTotals);

	return {
		currency: state.company?.settings?.currency,
		periodTotal,
		readyEmployees: ready?.length,
		notReadyTotal,
		notReadyEmployees: notReady?.length,
		profile: state?.my?.profile,
		advisor: state?.advisors?.settings?.agent,
		period: state.payroll?.payPeriodDetails,
		org: state?.company?.settings?.org,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setOpenModal: () => dispatch(PAYROLL_ACTIONS.setOpenApprovalModal(true)),
	approvePayPeriod: (id) => dispatch(PAYROLL_ACTIONS.reviewPayPeriod({ id, action: "Approved" })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollApproval);
